import type { MatchSummary } from '@seven-dawns/shared';

/** Row subtitle: "Lobby · 3/4 players", "Day 3/7 · You're on Azure", "Finished". */
export function summaryLine(summary: MatchSummary, playerName: string): string {
  if (summary.status === 'finished') return 'Finished';
  const players = summary.teams.reduce((n, t) => n + t.players.filter((p) => !p.isAi).length, 0);
  const slots = summary.config.teamSlots[0] + summary.config.teamSlots[1];
  if (summary.status === 'lobby') return `Lobby · ${players}/${slots} players`;
  const team = summary.teams.find((t) => t.players.some((p) => p.name === playerName));
  return `Day ${summary.day ?? 1}/${summary.config.durationDays}${team ? ` · You're on ${team.name}` : ' · Relic Hunt'}`;
}
